<template>
    <b-modal
        id="portfolio-calender-item-settings-modal"
        v-model="modal"
        size="md"
        ref="portfolio-calender-item-settings-modal"
        title="Agenda item"
        ok-only
        :ok-title="$t('common.close')"
        cancel-variant="outline-primary"
        dialog-class="assignment-modal"
        modal-class="apprentice-default-modal"
        :no-enforce-focus="true">
        <div class="agenda-item-details">
            <div class="component-title">
                <a
                    class="title assignment-deadline"
                    v-if="itemIn.isDeadline"
                    href="#"
                    @click.prevent.stop="showAssignment">
                    {{ itemIn.title }}
                </a>
                <h5
                    class="title"
                    v-else>
                    {{ itemIn.title }}
                </h5>

                <div
                    class="group-actions"
                    v-if="canUpdate">
                    <b-button
                        class="btn-edit btn-edit-group remove-icon-margin"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('portfolio.edit_agenda_item')"
                        @click="updateItem()">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-group remove-icon-margin"
                        variant="danger-icon-only"
                        :v-b-tooltip="$t('portfolio.edit_agenda_item')"
                        @click="deleteItem()">
                    </b-button>
                </div>
            </div>

            <div class="agenda-item-content">
                <div
                    class="whole-day"
                    v-if="itemIn.allDay">
                    <span class="label">{{ $t('portfolio.duration') }}</span>
                    <span>{{ $t('portfolio.all_day') }}</span>
                </div>
                <div
                    class="start-date"
                    v-if="!itemIn.allDay">
                    <span class="label">{{ getStartDateLabel() }}</span>
                    <span v-if="itemIn.time">{{ startDate | date_time_om_year }}</span>
                    <span v-else>{{ itemIn.date | date_named_month }}</span>
                </div>

                <div
                    class="end-date"
                    v-if="itemIn.time_end && itemIn.date_end">
                    <span class="label">{{ $t('portfolio.end_date') }}</span>
                    <span v-if="itemIn.time_end">{{ endDate | date_time_om_year }}</span>
                    <span v-else>{{ itemIn.date_end | date_named_month }}</span>
                </div>

                <div
                    class="location"
                    v-if="itemIn.location">
                    <span class="label">{{ $t('common.location') }}</span>
                    {{ itemIn.location }}
                </div>

                <div
                    class="description"
                    v-if="itemIn.description">
                    <div class="label">{{ $t('common.description') }}</div>
                    <design-2021-apprentice-display-html-component :html-content="itemIn.description">
                    </design-2021-apprentice-display-html-component>
                </div>
            </div>

            <div class="calendar-redirect">
                <b-button
                    v-if="itemIn.redirect"
                    variant="primary"
                    @click="redirect">
                    {{ $t('portfolio.view_appointment') }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-show-calendar-settings-modal-component',
    props: ['itemIn'],
    data() {
        return {
            modal: false,
        };
    },
    computed: {
        canUpdate() {
            if (this.itemIn.roadmap) {
                return false;
            }

            if (this.itemIn && this.itemIn.created_by === this.$authUser.id) {
                return true;
            }

            if (this.$authUser.isAdmin()) {
                return true;
            }

            return;
        },

        startDate() {
            return this.itemIn.date + ' ' + this.itemIn.time;
        },

        endDate() {
            return this.itemIn.date_end + ' ' + this.itemIn.time_end;
        },
    },
    methods: {
        redirect() {
            window.location.href = this.itemIn.redirect;
        },

        updateItem() {
            this.modal = false;
            this.$emit('update-item');
        },

        deleteItem() {
            this.modal = false;
            this.$emit('delete-item');
        },

        show() {
            this.modal = true;
        },

        showAssignment() {
            window.location.href = this.routes.assignmentShow(this.itemIn.assignment_id, this.itemIn.project_id);
        },

        getStartDateLabel() {
            if (!this.itemIn.model_type) {
                return 'Startdatum:';
            }

            const modelType = this.itemIn.model_type.split('\\');

            switch (modelType.pop().toLowerCase()) {
                case 'assignmentdeadline':
                case 'subassignmentdeadline':
                    return 'Deadline:';

                case 'roadmapstep':
                    return this.$t('portfolio.deadline_roadmap');

                case 'personalgoaltaskdeadline':
                    return this.$t('portfolio.deadline_personal_task');

                default:
                    return this.$t('portfolio.start_date');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.agenda-item-details {
    span.label {
        margin-bottom: 0;
    }

    .start-date,
    .end-date,
    .location,
    .whole-day {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        span:nth-of-type(2) {
            color: $text-muted-color;
            margin-left: map-get($grid-gutter-spacing, 'eight');
            font-size: $default-font-size;
        }
    }

    .description {
        color: $text-muted-color;

        .label {
            color: $text-color;
        }
    }
}

.group-actions {
    display: flex;

    .btn {
        font-size: 1.125rem;
        align-self: flex-start;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.component-title {
    .title {
        width: calc(100% - 68px);
    }
}

.calendar-redirect {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
